import { render, staticRenderFns } from "./remindcomp.vue?vue&type=template&id=f7597d24&scoped=true&"
import script from "./remindcomp.vue?vue&type=script&lang=js&"
export * from "./remindcomp.vue?vue&type=script&lang=js&"
import style0 from "./remindcomp.vue?vue&type=style&index=0&id=f7597d24&prod&scoped=true&lang=css&"
import style1 from "./remindcomp.vue?vue&type=style&index=1&id=f7597d24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7597d24",
  null
  
)

export default component.exports